// src/redux/services/SezInfoSlice.js
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  mapSezinfoResponse,
  mapSezinfoRequest,
} from "@/redux/mappers/Export/CreateNewJob/SezInfoMappers";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";  

export const importSezInfoApi = createApi({
  reducerPath: "importSezInfoApi",
  baseQuery,
  tagTypes: ["importSezInfo"],
  endpoints: (builder) => ({
    // ✅ Fetch by ExportMasterId
    getImportSezInfoById: builder.query({
      query: ({id}) => `/import/sez/${id}`,
      transformResponse: (response) =>{
        return response?.data
    } ,
      providesTags: (result, error, id) => [{ type: "importSezInfo", id }],
    }),

    // ✅ Update SEZ info (PUT)
    createImportSezInfo: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/import/sez/${id}`,
        method: "PUT",
        headers: {
          "X-Request-Id": crypto.randomUUID(),
        },
        body: {sez: data},
      }),
      invalidatesTags: ["importSez"],
    }),
  }),
});

export const {
  useLazyGetImportSezInfoByIdQuery,
  useCreateImportSezInfoMutation,
} = importSezInfoApi;


